import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Facture from '../../../Components/Docs/Facture';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import {statutPaiementEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getLastWorkingDayOfMonth } from '../../../Utils/getCalendarMonthMatrix';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue, sortDate} from '../../../Utils/utils';
import { getMontatantTTC } from '../../../Utils/utilsCraX';
import HeaderAllFacture from './HeaderAllFacture';

const AllFactureExpert = () => {
    const { addEuro4Decimal } = useNumberFormatting();

    const { setBackdropOpen} = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const [factureRows, setFactureRows] = useState([]);
    const [rowselected, setRowSelected] = useState();
    const [url, setUrl] = useState('');
    const [open, setOpen] = useState(false);
    const { i18n } = useTranslation();
    const location = useLocation();
    const role=useRole();
    const searchParams = new URLSearchParams(location.search);
    const [filtreFactureExpertNonPaye, setFiltreFactureExpertNonPaye] = useState(searchParams.get('filtreFactureExpertNonPaye') === 'true');
    const factureColumns4Expert = [
        {
            field: 'refFactureExpert',
            title: i18n.t('Réf. Facture'),
        },
        {
            field: 'dateEmission',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateEmission),
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du Client'),
        },
        ...(role=='esn' ?
            [{
                field: 'nomExpert',
                title: i18n.t('Nom de l\'expert'),
            }]:[]
        ),
        {
            field: 'refCra',
            title: i18n.t('Réf.CRA'),
        },
        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statutPaiementExpert',
            title: i18n.t('Statut paiement'),
        },
        {
            field: 'datePaiementExpert',
            title: i18n.t('Date Paiement/Expert'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementExpert)
        },
        {
            field: 'periode',
            title: i18n.t('Période'),
            //render:  rowData =>
            //    searchLabelInEnumByValue(MonthsString,(rowData?.periode)),
        },
        {
            field: 'dateEcheance',
            title: i18n.t('Date d\'échéance'),
        },
        {
            field: 'nbJour',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }
        },
        {
            field: 'tjExpert',
            title: i18n.t('Taux journalier HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjExpert)
        },
        {
            field: 'totalHTExpert',
            title: i18n.t('Total HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHTExpert)
        },
        {
            field: 'tvaExpert',
            title: i18n.t('TVA appliquée'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tvaExpert,' %'),

        },
        {
            field: 'totalTTCExpert',
            title: i18n.t('Total TTC'),
            render:  rowData =>
                addEuro4Decimal(getMontatantTTC(rowData?.totalHTExpert, rowData?.tvaExpert )),
        },
        {
            field: 'respOperationnel',
            title: i18n.t('Resp.Opérationnel'),
        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        }
        ,
        ...(role=='esn' ?
            [{
                field: 'Commercial',
                title: i18n.t('commercial ESN'),
            }]:
            []),
    ];

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtrefactureexpertnonpaye')  ){
            setFiltreFactureExpertNonPaye(false);
        }
    }, [url]);

    useEffect(() => {
        getMyFactures();
    }, [filtreFactureExpertNonPaye]);

    useEffect(() => {
        getMyFactures();
    }, []);

    //=============================================================================

    const getMyFactures = async () => {
        setBackdropOpen(true);
        const endpoint = role === 'esn'
            ? '/facture/getMyFactures/'
            : '/facture/getMyFactures?isAchat=false';
        try {
            const response = await axiosPrivate.get(endpoint, {
                // signal: controller.signal
            });

            let listFacture = await response.data?.factures;
            let Array1=[];
            if(filtreFactureExpertNonPaye){
                listFacture?.reverse().forEach(facture => {
                    const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
                    if((facture?.statutFacture=='genere'||facture?.statutFacture=='groupe'||facture?.statutFactureX=='genere'||facture?.statutFactureX=='groupe')&&(facture?.statutPaimentExpert=='nonPaye')){
                        // 4 BackOffice
                        Array1.push({
                            isCraOrCraX,
                            'id': facture?._id,
                            'refFactureExpert':facture?.refFacture ? facture?.refFacture + 'E': 'Proforma expert',
                            //'refFactureExpert': facture?.craId?.nbrDays ? facture?.factureId + 'E' : facture?.factureXId + 'E',
                            'refCra': facture?.[isCraOrCraX]?.[isCraOrCraX],
                            'refClient': facture?.[isCraOrCraX]?.missionId?.companyDataId?.clientId ?? facture?.[isCraOrCraX]?.missionId?.esnId?.esnId,
                            'nomClient': facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.nom ?? facture?.[isCraOrCraX]?.missionId?.esnId?.profileEntreprise?.nom,
                            'nomExpert':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.missionId?.expertId?.persoData),
                            'intituleMission': facture?.[isCraOrCraX]?.missionId?.titre,
                            'dateValidationCra': Date(facture?.[isCraOrCraX]?.DateVC) > Date(facture?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVE),
                            'dateEmission': formatDateJJMMYYYY(facture?.dateEmission),
                            'Date':facture?.dateEmission,
                            'Statut': facture?.craId?.nbrDays ? (facture?.statutFacture=='groupe')?'genere':facture?.statutFacture: (facture?.statutFactureX=='groupe')?'genere':facture?.statutFactureX,
                            //'periode':facture?.[isCraOrCraX]?.month,
                            'periode':
                                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY')
                            ,
                            'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                                dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                                (facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',facture?.delaiPaiement)),
                            //'dateEcheance':formatDateJJMMYYYY(moment(facture?.dateEmission).add('days',facture?.delaiPaiement)),
                            'statutPaiementExpert':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,facture?.statutPaimentExpert)),
                            'datePaiementExpert':facture?.datePaimentExpert,
                            'nbJour':facture?.craId?.nbrDays,
                            'tjExpert':facture?.[isCraOrCraX]?.tj,
                            'hnos':facture?.[isCraOrCraX]?.hnos,
                            'astreintes':facture?.[isCraOrCraX]?.astreintes,
                            'notesFrais':facture?.[isCraOrCraX]?.notesFrais,
                            'tvaExpert':facture?.tva ?? facture?.[isCraOrCraX]?.missionId?.esnExpertOwnerId?.donneeFacturation?.tauxTva ?? facture?.[isCraOrCraX]?.missionId?.expertId?.entreprise?.tauxTva,

                            'totalAstreinte':facture?.craXId?.totalAstreintes,
                            'totalHnoClient':facture?.craXId?.totalHnosClient,
                            'totalHnoExpert':facture?.craXId?.totalHnos,
                            'totalNotesFrais': facture?.craXId?.totalNotesFrais,

                            'totalHTExpert':facture?.[isCraOrCraX]?.nbrDays ?(facture?.[isCraOrCraX]?.nbrDays * facture?.[isCraOrCraX]?.tj): facture?.[isCraOrCraX]?.montantTotal,

                            'respOperationnel':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData  ?? facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelEsnId?.persoData),
                            'chargeRecrutement':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
                            'Commercial':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.collaboratorEsnExpertId?.persoData),
                            // 'totalTva':
                            ...facture
                        });
                    }
                });
            }
            else{
                listFacture?.reverse().forEach(facture => {
                    const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
                    // 4 BackOffice
                    Array1.push({
                        isCraOrCraX,
                        'id': facture?._id,
                        'refFactureExpert':facture?.refFacture ? facture?.refFacture + 'E': 'Proforma expert',
                        //'refFactureExpert': facture?.craId?.nbrDays ? facture?.factureId + 'E' : facture?.factureXId + 'E',
                        'refCra': facture?.[isCraOrCraX]?.[isCraOrCraX],
                        'refClient': facture?.[isCraOrCraX]?.missionId?.companyDataId?.clientId ?? facture?.[isCraOrCraX]?.missionId?.esnId?.esnId,
                        'nomClient': facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.nom ?? facture?.[isCraOrCraX]?.missionId?.esnId?.profileEntreprise?.nom,
                        'nomExpert':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.missionId?.expertId?.persoData),
                        'intituleMission': facture?.[isCraOrCraX]?.missionId?.titre,
                        'dateValidationCra': Date(facture?.[isCraOrCraX]?.DateVC) > Date(facture?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(facture?.[isCraOrCraX]?.DateVE),
                        'dateEmission': formatDateJJMMYYYY(facture?.dateEmission),
                        'Date':facture?.dateEmission,
                        'Statut': facture?.craId?.nbrDays ? facture?.statutFacture : facture?.statutFactureX,
                        //'periode':facture?.[isCraOrCraX]?.month,
                        'periode':
                            dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY')
                        ,
                        'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                            dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                            dayjs(new Date(facture?.[isCraOrCraX]?.year, facture?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                            (facture?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',facture?.delaiPaiement)),
                        //'dateEcheance':formatDateJJMMYYYY(moment(facture?.dateEmission).add('days',facture?.delaiPaiement)),
                        'statutPaiementExpert':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,facture?.statutPaimentExpert)),
                        'datePaiementExpert':facture?.datePaimentExpert,
                        'nbJour':facture?.craId?.nbrDays,
                        'tjExpert':facture?.[isCraOrCraX]?.tj,
                        'hnos':facture?.[isCraOrCraX]?.hnos,
                        'astreintes':facture?.[isCraOrCraX]?.astreintes,
                        'notesFrais':facture?.[isCraOrCraX]?.notesFrais,
                        'tvaExpert': facture?.tva,

                        'totalAstreinte':facture?.craXId?.totalAstreintes,
                        'totalHnoClient':facture?.craXId?.totalHnosClient,
                        'totalHnoExpert':facture?.craXId?.totalHnos,
                        'totalNotesFrais': facture?.craXId?.totalNotesFrais,

                        'totalHTExpert':facture?.[isCraOrCraX]?.nbrDays ?(facture?.[isCraOrCraX]?.nbrDays * facture?.[isCraOrCraX]?.tj): facture?.[isCraOrCraX]?.montantTotal,

                        'respOperationnel':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData ?? facture?.[isCraOrCraX]?.bdcId?.responsableOperationnelEsnId?.persoData),
                        'chargeRecrutement':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
                        'Commercial':getNomPrenomClearFromPersoData(facture?.[isCraOrCraX]?.bdcId?.collaboratorEsnExpertId?.persoData),
                        // 'totalTva':
                        ...facture
                    });
                });
            }

            setFactureRows(sortDate(Array1));
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    const [selectedRow, setSelectedRow] = React.useState(null);

    return (
        <>

            <div className='frame5Profile'>
                {i18n.t('CRA & Factures')}
                {role === 'esn' && (
                    <>
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Vente')}</span>
                    </>
                )}
                &gt;
                <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Factures')}</span>
            </div>

            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Factures')}
                </h4>
                <HeaderAllFacture />
                <MaterialTableComponent
                    title="Factures"
                    data={factureRows}
                    columns={factureColumns4Expert}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        setRowSelected(rowData);
                        setOpen(true);
                    }}
                    selectedRow={selectedRow}
                />
            </div>
            {open &&
            <Facture
                handleClose={()=>{
                    setOpen(false);
                }}
                facture={rowselected}
                open={open}
                role={'expert'}
            />}
        </>
    );
};

export default AllFactureExpert;
